
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A short phrase describing the position as it would be listed on a business card or in a company directory.`}</p>
    <p>{`This field has a maximum length of 80 characters.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;